import { createFileRoute } from "@tanstack/react-router";
import ServiceDetail from "@/pages/ServiceDetail";
import { getScreedSystem } from "@/data/screedSystems";

export const Route = createFileRoute("/services/$slug")({
  head: ({ params }) => {
    const system = getScreedSystem(params.slug);
    if (!system) {
      return {
        meta: [
          { title: "Service Not Found | Exeter Flow Screeds" },
          { name: "description", content: "Service page not found." },
        ],
      };
    }

    const pageTitle = `${system.metaTitle}`;
    const pageDesc = system.metaDescription;
    const pageUrl = `https://exeterflowscreed.co.uk/services/${system.slug}`;
    const pageImage =
      "https://assets.cdn.filesafe.space/iehMW4z3GZgoPjqmxz5p/media/6a85f76b5113a1715f109275.webp";

    return {
      meta: [
        { title: pageTitle },
        { name: "description", content: pageDesc },
        { property: "og:title", content: pageTitle },
        { property: "og:description", content: pageDesc },
        { property: "og:url", content: pageUrl },
        { property: "og:image", content: pageImage },
        { name: "twitter:title", content: pageTitle },
        { name: "twitter:description", content: pageDesc },
        { name: "twitter:image", content: pageImage },
      ],
      links: [{ rel: "canonical", href: pageUrl }],
    };
  },
  component: ServiceDetail,
});
